<ion-menu [contentId]="contentId()" [menuId]="menuId()" swipeGesture="false">
  <div class="more-menu-container">
    <fa-icon
      class="close-icon"
      [icon]="faCircleChevronLeft"
      (click)="closeMenu.emit()"
    />
    <ng-content />
  </div>
</ion-menu>
